var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "quick-responses" } },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-between align-items-center" },
        [
          _c("a-input-search", {
            staticClass: "search-input",
            attrs: { placeholder: _vm.$t("message.search") },
            model: {
              value: _vm.searchText,
              callback: function ($$v) {
                _vm.searchText = $$v
              },
              expression: "searchText",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex align-items-center" },
            [
              _vm.checkPermission(
                _vm.PERMISSION_TYPES["prepared.create"].tr.name
              )
                ? _c(
                    "supsis-button",
                    {
                      staticStyle: { "margin-right": "8px" },
                      attrs: { primary: "" },
                      on: { click: _vm.openNewTitleFormModal },
                    },
                    [
                      _c("md-icon", { staticStyle: { color: "white" } }, [
                        _vm._v("add"),
                      ]),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("message.newTitleContent")) +
                          "\n            "
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "supsis-button",
                {
                  attrs: { primary: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$feature.beforeCreateReadyContent(
                        _vm.openNewContentFormModal
                      )
                    },
                  },
                },
                [
                  _c("md-icon", { staticStyle: { color: "white" } }, [
                    _vm._v("add"),
                  ]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.newDefaultContent")) +
                      "\n            "
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "draggable",
            {
              staticClass: "row m-1",
              model: {
                value: _vm.contentOrdered,
                callback: function ($$v) {
                  _vm.contentOrdered = $$v
                },
                expression: "contentOrdered",
              },
            },
            _vm._l(_vm.cloneGrouped, function (content, index) {
              return _c(
                "b-col",
                { key: index, staticClass: "mt-5", attrs: { md: "4" } },
                [
                  _c("div", { staticClass: "custom-card" }, [
                    _c("div", { staticClass: "header" }, [
                      _c(
                        "div",
                        { staticClass: "hoverTools" },
                        [
                          _c(
                            "a-button",
                            {
                              staticClass: "mx-2",
                              attrs: {
                                icon: "plus",
                                size: "small",
                                type: "primary",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openAddContentToTitleFormModal(
                                    content,
                                    _vm.CONTENT_TYPES.ALT
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      _vm.isMac
                                        ? "message.newCTRLContent"
                                        : "message.newALTContent"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              staticClass: "mx-2",
                              attrs: {
                                icon: "plus",
                                size: "small",
                                type: "primary",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openAddContentToTitleFormModal(
                                    content,
                                    _vm.CONTENT_TYPES.TAB
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$t("message.newTABContent")) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              staticClass: "mx-2",
                              attrs: {
                                icon: "plus",
                                size: "small",
                                type: "primary",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openAddContentToTitleFormModal(
                                    content,
                                    _vm.CONTENT_TYPES.HASH
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$t("message.newHASHContent")) +
                                  "\n                            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.getContentName(content)))]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "actions" },
                        [
                          _c(
                            "a-button",
                            {
                              staticClass:
                                "actionButton d-flex align-items-center",
                              on: {
                                click: function ($event) {
                                  return _vm.edit(content._id)
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-right": "10px",
                                    display: "block",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("message.edit")))]
                              ),
                              _vm._v(" "),
                              _c("ActionEdit"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !content.hasOwnProperty("children") ||
                          content.children.length === 0
                            ? _c(
                                "a-button",
                                {
                                  staticClass:
                                    "actionButton d-flex align-items-center",
                                  on: {
                                    click: function ($event) {
                                      return _vm.remove(content._id)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "margin-right": "10px",
                                        display: "block",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("message.deleteField"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("ActionDelete"),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { "overflow-y": "auto" } },
                      [
                        _c(
                          "draggable",
                          {
                            key: content._id,
                            staticClass: "body",
                            attrs: {
                              id: content._id,
                              move: _vm.move,
                              value: _vm.getChildren(content),
                              group: "contents",
                            },
                            on: { end: _vm.moveEnd },
                          },
                          _vm._l(_vm.getChildren(content), function (child) {
                            return _c(
                              "div",
                              {
                                key: child._id,
                                staticClass: "item",
                                attrs: { id: child._id },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "tippy",
                                        rawName: "v-tippy",
                                        value: {
                                          followCursor: true,
                                          placement: "right",
                                          theme: _vm.isDarkMode
                                            ? "light-border"
                                            : "google",
                                        },
                                        expression:
                                          "{\n                                        followCursor: true,\n                                        placement: 'right',\n                                        theme: isDarkMode ? 'light-border' : 'google',\n                                    }",
                                      },
                                    ],
                                    staticClass: "d-flex align-items-center",
                                    staticStyle: {
                                      cursor: "help",
                                      width: "calc(100% - 100px)",
                                    },
                                    attrs: {
                                      content: _vm.getContentName(
                                        child,
                                        "content"
                                      ),
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "shortcuts" }, [
                                      child.type === "ALT"
                                        ? _c(
                                            "div",
                                            { staticClass: "shortcut" },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    _vm.isMac
                                                      ? "CTRL"
                                                      : child.type
                                                  ) +
                                                  "\n                                            +\n                                            " +
                                                  _vm._s(child.letter) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          )
                                        : child.type === "TAB"
                                        ? _c(
                                            "div",
                                            { staticClass: "shortcut" },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(child.letter) +
                                                  "\n                                            "
                                              ),
                                              _c("right-button"),
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(child.type) +
                                                  "\n                                            "
                                              ),
                                              _c("right-button"),
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(child.number) +
                                                  "\n                                        "
                                              ),
                                            ],
                                            1
                                          )
                                        : child.type === "HASH"
                                        ? _c(
                                            "div",
                                            { staticClass: "shortcut" },
                                            [
                                              _vm._v(
                                                "\n                                            #" +
                                                  _vm._s(child.hash) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "contentInfo" }, [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(_vm.getContentName(child)) +
                                          "\n                                    "
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "actions" },
                                  [
                                    _c(
                                      "a-button",
                                      {
                                        staticClass:
                                          "actionButton d-flex align-items-center",
                                        on: {
                                          click: function ($event) {
                                            return _vm.edit(child._id, true)
                                          },
                                        },
                                      },
                                      [_c("ActionEdit")],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.checkPermission(
                                      _vm.PERMISSION_TYPES["prepared.delete"].tr
                                        .name
                                    )
                                      ? _c(
                                          "a-button",
                                          {
                                            staticClass:
                                              "actionButton d-flex align-items-center",
                                            on: {
                                              click: function ($event) {
                                                return _vm.remove(child._id)
                                              },
                                            },
                                          },
                                          [_c("ActionDelete")],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isModalShow
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "content-form",
                "show-footer": false,
                title: _vm.editMode
                  ? _vm.$t("message.updateDefaultContentForm")
                  : _vm.$t("message.newDefaultContentForm"),
              },
              on: { cancel: _vm.hideModal },
            },
            [
              _c(
                "div",
                { attrs: { id: "modal-inner" } },
                [
                  _vm.$validator.errors.items.length && _vm.submitClicked
                    ? _c(
                        "a-alert",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            message: _vm.$t("message.error"),
                            showIcon: "",
                            type: "error",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              attrs: { slot: "description" },
                              slot: "description",
                            },
                            _vm._l(
                              _vm.$validator.errors.items,
                              function (err, index) {
                                return _c("div", { key: "err-" + index }, [
                                  _c("span", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(err.msg) +
                                        "\n                        "
                                    ),
                                  ]),
                                ])
                              }
                            ),
                            0
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      staticClass: "d-flex flex-column justify-content-center",
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.handleSave.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _vm.isChild
                                    ? _c(
                                        "b-col",
                                        { attrs: { md: "12" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "message.contentType"
                                                ),
                                                "label-for": "type-input",
                                              },
                                            },
                                            [
                                              _c(
                                                "b-form-select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: "required",
                                                      expression: "'required'",
                                                    },
                                                  ],
                                                  attrs: {
                                                    id: "type-input",
                                                    "data-vv-as": _vm.$t(
                                                      "message.contentType"
                                                    ),
                                                    name: _vm.$t(
                                                      "message.contentType"
                                                    ),
                                                    type: "text",
                                                  },
                                                  model: {
                                                    value: _vm.content.type,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.content,
                                                        "type",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "content.type",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "option",
                                                    {
                                                      domProps: {
                                                        value: undefined,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.pickOne"
                                                          )
                                                        ) + "..."
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "option",
                                                    { attrs: { value: "ALT" } },
                                                    [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            _vm.isMac
                                                              ? "CTRL"
                                                              : "ALT"
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "option",
                                                    { attrs: { value: "TAB" } },
                                                    [_vm._v("TAB")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "option",
                                                    {
                                                      attrs: { value: "HASH" },
                                                    },
                                                    [_vm._v("#HASH")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "option",
                                                    {
                                                      attrs: { value: "TITLE" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.title"
                                                            )
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  (_vm.content.type || "").toLowerCase() !==
                                  "title"
                                    ? _c(
                                        "b-col",
                                        { attrs: { md: "12" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "type-input-group",
                                                label: "Grup",
                                                "label-for": "type-input",
                                              },
                                            },
                                            [
                                              _c("b-form-select", {
                                                attrs: {
                                                  id: "type-input",
                                                  options: _vm.contents.data
                                                    .filter(function (c) {
                                                      return c.parentId === null
                                                    })
                                                    .map(function (c) {
                                                      return {
                                                        value: c._id,
                                                        text: _vm.getContentName(
                                                          c
                                                        ),
                                                      }
                                                    }),
                                                  name: "type",
                                                  type: "text",
                                                },
                                                model: {
                                                  value: _vm.content.parentId,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.content,
                                                      "parentId",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "content.parentId",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      (_vm.content.type || "").toLowerCase() ===
                                      "alt"
                                        ? _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "letter-input-group",
                                                label: _vm.$t(
                                                  "message.shortcutChar"
                                                ),
                                                "label-for": "letter-input",
                                              },
                                            },
                                            [
                                              _c("b-form-input", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value:
                                                      "required|alpha_num|length:1|excluded:e,d,f,z,a,x,c,v,w,t,n",
                                                    expression:
                                                      "'required|alpha_num|length:1|excluded:e,d,f,z,a,x,c,v,w,t,n'",
                                                  },
                                                ],
                                                attrs: {
                                                  id: "letter-input",
                                                  "data-vv-as": _vm.$t(
                                                    _vm.content.letter
                                                  ),
                                                  name: _vm.$t(
                                                    "message.shortcutChar"
                                                  ),
                                                  placeholder: _vm.$t(
                                                    "message.writeSomething"
                                                  ),
                                                  autocomplete: "off",
                                                  trim: "",
                                                  type: "text",
                                                },
                                                model: {
                                                  value: _vm.content.letter,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.content,
                                                      "letter",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "content.letter",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "em",
                                                {
                                                  staticClass:
                                                    "font-weight-light",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("message.shortcut")
                                                    ) +
                                                      ": alt + " +
                                                      _vm._s(_vm.content.letter)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "em",
                                                {
                                                  staticClass:
                                                    "d-block font-weight-light",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.forMacUsers"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "em",
                                                {
                                                  staticClass:
                                                    "d-block font-weight-light text-danger",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("message.notValid")
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("b-col", { attrs: { md: "12" } }, [
                                    _c(
                                      "div",
                                      [
                                        (
                                          _vm.content.type || ""
                                        ).toLowerCase() === "tab"
                                          ? _c(
                                              "b-row",
                                              {
                                                staticClass:
                                                  "align-items-center",
                                              },
                                              [
                                                _c(
                                                  "b-col",
                                                  { attrs: { md: "5" } },
                                                  [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "message.letterSequence"
                                                          ),
                                                          "label-for":
                                                            "letter-input",
                                                        },
                                                      },
                                                      [
                                                        _c("b-form-input", {
                                                          directives: [
                                                            {
                                                              name: "validate",
                                                              rawName:
                                                                "v-validate",
                                                              value: "required",
                                                              expression:
                                                                "'required'",
                                                            },
                                                          ],
                                                          attrs: {
                                                            id: "letter-input",
                                                            "data-vv-as":
                                                              _vm.$t(
                                                                "message.letterSequence"
                                                              ),
                                                            name: _vm.$t(
                                                              "message.letterSequence"
                                                            ),
                                                            placeholder: _vm.$t(
                                                              "message.exampleText"
                                                            ),
                                                            autocomplete: "off",
                                                            trim: "",
                                                            type: "text",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.content
                                                                .letter,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.content,
                                                                "letter",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "content.letter",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass: "text-center",
                                                    attrs: { md: "2" },
                                                  },
                                                  [
                                                    _c(
                                                      "b-badge",
                                                      { staticClass: "mt-2" },
                                                      [_vm._v("TAB")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  { attrs: { md: "5" } },
                                                  [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          id: "number-input-group",
                                                          label:
                                                            _vm.$t(
                                                              "message.shorcutKey"
                                                            ),
                                                          "label-for":
                                                            "number-input",
                                                        },
                                                      },
                                                      [
                                                        _c("b-form-input", {
                                                          directives: [
                                                            {
                                                              name: "validate",
                                                              rawName:
                                                                "v-validate",
                                                              value:
                                                                "required|length:1",
                                                              expression:
                                                                "'required|length:1'",
                                                            },
                                                          ],
                                                          attrs: {
                                                            id: "number-input",
                                                            "data-vv-as":
                                                              _vm.$t(
                                                                "message.shorcutKey"
                                                              ),
                                                            name: _vm.$t(
                                                              "message.shorcutKey"
                                                            ),
                                                            placeholder:
                                                              _vm.$t(
                                                                "message.anyChar"
                                                              ),
                                                            autocomplete: "off",
                                                            trim: "",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.content
                                                                .number,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.content,
                                                                "number",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "content.number",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("MultiContent", {
                                          ref: "MultiContent",
                                          model: {
                                            value: _vm.multiContentComp,
                                            callback: function ($$v) {
                                              _vm.multiContentComp = $$v
                                            },
                                            expression: "multiContentComp",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      (_vm.content.type || "").toLowerCase() ===
                                      "hash"
                                        ? _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "hashText",
                                                label:
                                                  _vm.$t("message.hashText"),
                                                "label-for": "hashText-input",
                                              },
                                            },
                                            [
                                              _c(
                                                "b-input-group",
                                                {
                                                  staticClass:
                                                    "mb-2 mr-sm-2 mb-sm-0",
                                                  attrs: { prepend: "#" },
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value:
                                                          "required|alpha_num",
                                                        expression:
                                                          "'required|alpha_num'",
                                                      },
                                                    ],
                                                    attrs: {
                                                      id: "hashText-input",
                                                      "data-vv-as": _vm.$t(
                                                        _vm.content.hash
                                                      ),
                                                      name: _vm.$t(
                                                        "message.hashText"
                                                      ),
                                                      placeholder: _vm.$t(
                                                        "message.exampleHash"
                                                      ),
                                                      autocomplete: "off",
                                                      trim: "",
                                                      type: "text",
                                                    },
                                                    model: {
                                                      value: _vm.content.hash,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.content,
                                                          "hash",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "content.hash",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "em",
                                                {
                                                  staticClass:
                                                    "d-block font-weight-light text-danger",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.notValidHash"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: _vm.$t("report.status"),
                                          },
                                        },
                                        [
                                          _c(
                                            "b-form-radio-group",
                                            {
                                              attrs: {
                                                name: "status",
                                                required: "",
                                              },
                                              model: {
                                                value: _vm.content.isActive,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.content,
                                                    "isActive",
                                                    $$v
                                                  )
                                                },
                                                expression: "content.isActive",
                                              },
                                            },
                                            [
                                              _c(
                                                "b-form-radio",
                                                { attrs: { value: true } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("message.active")
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-form-radio",
                                                { attrs: { value: false } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("message.passive")
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12", id: "buttons" } },
                                    [
                                      _c(
                                        "b-button",
                                        { on: { click: _vm.hideModal } },
                                        [
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.$t("message.cancel")
                                                ) +
                                                "\n                                    "
                                            ),
                                          ],
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            disabled: _vm.loading,
                                            type: "submit",
                                            variant: "primary",
                                          },
                                        },
                                        [
                                          !_vm.loading
                                            ? [
                                                !_vm.editMode
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.save"
                                                            )
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ])
                                                  : _c("span", [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.update"
                                                            )
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ]),
                                              ]
                                            : [
                                                _vm.checkPermission(
                                                  _vm.PERMISSION_TYPES[
                                                    "prepared.update"
                                                  ].tr.name
                                                )
                                                  ? _c(
                                                      "span",
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            attrs: {
                                                              icon: "spinner",
                                                              spin: "",
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ],
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }